var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticStyle:{"margin-top":"320px","height":"300px","line-height":"200px"},attrs:{"bordered":false}},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v("The toolset for device")])])])}
var staticRenderFns = []

export { render, staticRenderFns }